import * as React from 'react';
import { WithChildrenCommonProps } from '@types';
import { Icon, IconNames } from '@components/icon';
import { Typography } from '@components/typography';
import { getFieldMessageStylesAsClassName } from './field-message-styles';
import { twMerge } from 'tailwind-merge';

export enum FieldMessageType {
  HINT = 'hint',
  INFO = 'info',
  ERROR = 'error',
  SUCCESS = 'success',
}
export interface IFieldMessageProps {
  /** Indicate the type of the message */
  type: FieldMessageType;
}

export type FieldMessageProps = WithChildrenCommonProps<IFieldMessageProps>;

export const FieldMessage = React.forwardRef(
  (
    props: FieldMessageProps,
    ref: React.ForwardedRef<HTMLSpanElement>
  ): JSX.Element => {
    const { type, children, className: classNameProp, ...rest } = props;

    const iconName = {
      [FieldMessageType.INFO]: IconNames.INFO_CIRCLE,
      [FieldMessageType.ERROR]: IconNames.CIRCLE_EXCLAMATION,
      [FieldMessageType.SUCCESS]: IconNames.CHECK,
    };

    const twClassName = twMerge(
      getFieldMessageStylesAsClassName(type),
      classNameProp
    );

    return (
      <span ref={ref} className={twClassName} {...rest}>
        {type !== FieldMessageType.HINT && (
          <span className="mr-1">
            <Icon name={iconName[type]} size={'sm'} solid={true} />
          </span>
        )}
        <Typography component="small" variant="small">
          {children}
        </Typography>
      </span>
    );
  }
);

FieldMessage.displayName = 'FieldMessage';
